import React, { useState, useRef, useEffect } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    IconButton,
    Paper,
    BottomNavigation,
    BottomNavigationAction,
    Button,
    TextField,
    Chip,
    Dialog
} from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import Badge from "@mui/material/Badge";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ReplayIcon from "@mui/icons-material/Replay";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChatIcon from "@mui/icons-material/Chat";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";

import user1 from "./dummyuser2.png";
import heartsBg from "./hearts4.png";
import heartsBg2 from "./hearts4.png";

export default function Discover() {
    const [onview, setOnview] = useState("swipes"); //swipes, profile, match, filters
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [matchedProfile, setMatchedProfile] = useState(null);
    const [matchedProfileImg, setMatchedProfileImg] = useState(null);
    const [backTo, setBackTo] = useState("Swipes");
    const [matchId, setMatchId] = useState(0);
    const [photoIndex, setPhotoIndex] = React.useState(0);
    const [fullScreenOpen, setFullScreenOpen] = useState(false);

    const [filters, setFilters] = useState({
        age_min: 18,
        age_max: 40,
        distance_km: 50,
        show_me: "everyone",
    });

    const [profiles, setProfiles] = useState([]);
    const startX = useRef(0);

    const [tab, setTab] = useState(0);
    const navigate = useNavigate();

    const profileView = (user_profile, action_from) => {
        // console.log(user_profile);
        setBackTo(action_from);
        if (action_from === "Swipes") {
            setSelectedProfile({
                photos: user_profile.user.photos,
                display_name: user_profile.display_name,
                age: user_profile.age,
                bio: user_profile.bio,
                relation_type: user_profile.relation_type
            });

        } else {
            setSelectedProfile({
                photos: user_profile.photos,
                display_name: user_profile.profile.display_name,
                age: user_profile.profile.age,
                bio: user_profile.profile.bio,
                relation_type: user_profile.profile.relation_type
            });
        }
        setOnview("profile");
    };

    const handleStart = (e) => {
        startX.current = e.touches ? e.touches[0].clientX : e.clientX;
    };

    const handleEnd = async (e, profile) => {
        const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        const diff = endX - startX.current;

        if (Math.abs(diff) > 80) {
            const type = diff > 0 ? "like" : "pass";
            //console.log(`Swipe: ${type} on user ${profile.user.id}`);
            const userData = await JSON.parse(localStorage.getItem("userSessionData"));
            const token = userData.token;

            const dataObj = {
                user_id: profile.user.id,
                type
            }

            console.log(dataObj);

            const baseUrl = apilink.link;
            await axios
                .post(`${baseUrl}/swipe`, dataObj, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                })
                .then((response) => {

                    // Find current index
                    const index = profiles.findIndex((p) => p.user.id === profile.user.id);

                    // Get current undo stack
                    let undoStack = JSON.parse(localStorage.getItem("undoSwipeStack")) || [];

                    console.log(response.data)
                    console.log(`Swipe Sent: ${type} on user ${profile.user.id}`);
                    remove(profile.user.id);
                    if (response.data.match === true) {
                        setMatchedProfile(response.data.swiped_profile);
                        setMatchedProfileImg(response.data.primary_pic[0]);
                        setMatchId(response.data.match_id);
                        setOnview("match");
                    } else {
                        // Add the new swipe at the top
                        undoStack.unshift({ profile, index });

                        // Keep only last 5
                        if (undoStack.length > 5) undoStack = undoStack.slice(0, 5);

                        // Save back to localStorage
                        localStorage.setItem("undoSwipeStack", JSON.stringify(undoStack));
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status === 403) {
                        // Daily limit reached
                        toast.warning(error.response.data.message, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        // Other errors
                        console.error(error.response ? error.response.data : error.message);
                    }
                });
        }
    };

    const action = async (type, profile) => {
        //console.log(`Action: ${type} on user ${profile.user.id}`);
        const userData = await JSON.parse(localStorage.getItem("userSessionData"));
        const token = userData.token;

        const dataObj = {
            user_id: profile.user.id,
            type
        }

        console.log(dataObj);

        const baseUrl = apilink.link;
        await axios
            .post(`${baseUrl}/swipe`, dataObj, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            })
            .then((response) => {

                // Find current index
                const index = profiles.findIndex((p) => p.user.id === profile.user.id);

                // Get current undo stack
                let undoStack = JSON.parse(localStorage.getItem("undoSwipeStack")) || [];

                console.log(response.data)
                console.log(`Action Sent: ${type} on user ${profile.user.id}`);
                remove(profile.user.id);

                if (response.data.match === true) {
                    setMatchedProfile(response.data.swiped_profile);
                    setMatchedProfileImg(response.data.primary_pic[0]);
                    setMatchId(response.data.match_id);
                    setOnview("match");
                } else {
                    // Add the new swipe at the top
                    undoStack.unshift({ profile, index });

                    // Keep only last 5
                    if (undoStack.length > 5) undoStack = undoStack.slice(0, 5);

                    // Save back to localStorage
                    localStorage.setItem("undoSwipeStack", JSON.stringify(undoStack));
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 403) {
                    // Daily limit reached
                    toast.warning(error.response.data.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                } else {
                    // Other errors
                    console.error(error.response ? error.response.data : error.message);
                }
            });
    };

    const goToChat = async (matchid, user_id, name, photo) => {
        console.log(matchid);
        try {
            const { token } = JSON.parse(localStorage.getItem("userSessionData"));
            const res = await axios.post(
                `${apilink.link}/chats/${matchid}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const chatData = {
                conversation_id: res.data.conversation_id,
                user_id,
                name,
                photo
            };

            console.log(chatData);

            localStorage.setItem("chatSessionData", JSON.stringify(chatData));
            navigate(`/chat`)
        } catch (err) {
            console.error(err.response?.data || err.message);
        }
    };
    const remove = (id) => {
        setProfiles((prev) => prev.filter((p) => p.user.id !== id));
    };

    const handleUndoSwipe = async () => {
        try {
            let undoStack = JSON.parse(localStorage.getItem("undoSwipeStack")) || [];

            if (undoStack.length === 0) {
                toast.warning("No swipe to undo", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return;
            }

            // Take the last swipe
            const { profile, index } = undoStack.pop();

            const { token } = JSON.parse(localStorage.getItem("userSessionData"));
            const dataObj = { user_id: profile.user.id };

            const response = await axios.post(
                `${apilink.link}/reverse-swipe`,
                dataObj,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.swipe_removed === true) {
                // Restore profile at original position
                setProfiles((prev) => {
                    if (prev.some((p) => p.user.id === profile.user.id)) return prev;

                    const newProfiles = [...prev];
                    newProfiles.splice(index, 0, profile);
                    return newProfiles;
                });

                // Save updated stack
                localStorage.setItem("undoSwipeStack", JSON.stringify(undoStack));
            } else {
                toast.error("Failed to undo swipe", {
                    position: "top-center",
                    autoClose: 5000,
                    theme: "light",
                });
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong while undoing swipe", {
                position: "top-center",
                autoClose: 5000,
                theme: "light",
            });
        }
    };


    useEffect(() => {
        const getAsyncData = async () => {
            const userData = await JSON.parse(localStorage.getItem("userSessionData"));
            const token = userData.token;
            const baseUrl = apilink.link;
            await axios
                .get(`${baseUrl}/discover`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                })

                .then((response) => {
                    console.log(response.data);
                    setProfiles(response.data);
                })
                .catch((error) => {
                    console.log(error.response.data.message);
                });
        };
        getAsyncData();
    }, []);

    return (
        <Box sx={{ height: "100vh", bgcolor: "#f4f6fb", display: "flex", flexDirection: "column" }}>
            {/* 🔝 Sticky Top Bar */}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 20,
                    backgroundImage: `
                    linear-gradient(to right, rgba(255,255,255,0.7), rgba(255,255,255,0.9)),
                    url(${heartsBg})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    p: 2,
                    borderBottom: "1px solid #eee",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                {onview === "swipes" && <>
                    <Typography variant="h6">Swipe</Typography>
                    <Box
                        onClick={handleUndoSwipe}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            cursor: "pointer",
                        }}
                    >
                        <IconButton
                            sx={{
                                bgcolor: "#f6f6f6",
                                width: 34,
                                height: 34,
                                borderRadius: "50%",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                                "&:hover": {
                                    bgcolor: "#eee",
                                },
                            }}
                        >
                            <ReplayIcon sx={{ color: "#010832" }} />
                        </IconButton>

                        <Typography
                            variant="caption"
                            sx={{
                                mt: 0.5,
                                fontSize: 10,
                                color: "#555",
                                fontWeight: 500,
                            }}
                        >
                            Undo Swipe
                        </Typography>
                    </Box>


                </>}
                {onview === "profile" && <>
                    <Typography variant="h6">Profile View</Typography>
                </>}
                {onview === "match" && <>
                    <Typography variant="h6">Match</Typography>
                </>}
                {onview === "filters" && <>
                    <Typography variant="h6">Filters</Typography>
                </>}
                <IconButton onClick={() => { if (onview === "filters") { setOnview("swipes") } else { setOnview("filters") } }}>
                    <FilterListIcon />
                </IconButton>
            </Box>

            {/* 📜 Scrollable cards */}
            <Box sx={{ flex: 1, overflowY: "auto", p: 2, marginBottom: '50px' }}>
                {onview === "swipes" && <>
                    {profiles.map((profile) => {
                        // Get primary photo path or fallback
                        const primaryPhoto = profile.user.photos.length > 0
                            ? profile.user.photos.find((photo) => photo.is_primary === 1)?.path || profile.user.photos[0]?.path
                            : null;

                        const profileImage = primaryPhoto
                            ? `${apilink.base_link}/storage/${primaryPhoto}`
                            : user1; // fallback dummy image

                        return (
                            <Card
                                key={profile.user.id}
                                onMouseDown={handleStart}
                                onMouseUp={(e) => handleEnd(e, profile)}
                                onTouchStart={handleStart}
                                onTouchEnd={(e) => handleEnd(e, profile)}
                                sx={{
                                    height: { xs: 240, sm: 260, md: 280 },
                                    maxHeight: 300,
                                    mb: 2,
                                    borderRadius: 3,
                                    display: "flex",
                                    overflow: "hidden",
                                    boxShadow: 3,
                                    bgcolor: "#fff",
                                }}
                            >
                                {/* Left white info */}
                                <CardContent sx={{ flex: 1, display: "flex", flexDirection: "column", pb: 2 }}>
                                    <Box>
                                        <Typography variant="h6">
                                            {profile.display_name}, {profile.age} <Typography color="#0288d1" sx={{ fontSize: "12px" }}>
                                                {profile.gender.charAt(0).toUpperCase() + profile.gender.slice(1)}

                                            </Typography>
                                        </Typography>
                                        <Typography color="text.secondary" mt={1}>
                                            {profile.bio?.split(' ').slice(0, 6).join(' ')}
                                            {profile.bio?.split(' ').length > 6 ? '...' : ''}
                                        </Typography>

                                        <Typography color="#0288d1" mt={1} sx={{ display: "flex", alignItems: "center", gap: 0.5, fontSize: "12px" }}>
                                            <SearchIcon color="info" fontSize="12px" /> {profile.relation_type}
                                        </Typography>
                                    </Box>

                                    {/* ❤️ ❌ ⭐ buttons inside card */}
                                    <Box sx={{ mt: "auto", display: "flex", gap: 1 }}>
                                        <IconButton onClick={() => action("pass", profile)}>
                                            <CloseIcon color="error" />
                                        </IconButton>
                                        <IconButton onClick={() => action("superlike", profile)}>
                                            <StarBorderIcon color="warning" />
                                        </IconButton>
                                        <IconButton onClick={() => action("like", profile)}>
                                            <FavoriteBorderIcon color="success" />
                                        </IconButton>
                                    </Box>
                                </CardContent>

                                {/* Right image */}
                                <Box
                                    sx={{
                                        width: "50%",
                                        height: "100%",
                                        backgroundImage: `url(${profileImage})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center",
                                        backgroundRepeat: "no-repeat",
                                        maxHeight: "100%",
                                        position: "relative",
                                    }}
                                >
                                    <IconButton
                                        sx={{
                                            position: "absolute",
                                            bottom: 8,
                                            right: 8,
                                            bgcolor: "rgba(255,255,255,0.85)",
                                        }}
                                        onClick={() => {
                                            profileView(profile, "Swipes");
                                        }}
                                    >
                                        <InfoOutlinedIcon />
                                    </IconButton>
                                </Box>
                            </Card>
                        );
                    })}

                </>}


                {onview === "profile" && selectedProfile && (
                    <Box>
                        {/* Back button */}
                        <IconButton
                            onClick={() => setOnview(backTo === "Swipes" ? "swipes" : "match")}
                            sx={{
                                bgcolor: "#f0f0f0",
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                "&:hover": { bgcolor: "#e0e0e0" },
                            }}
                        >
                            <ArrowBackIcon fontSize="small" />
                        </IconButton>

                        <Card sx={{ borderRadius: 3, overflow: "hidden", mt: 1, maxWidth: 420, mx: "auto" }}>
                            {/* Arrange photos: primary first */}
                            {(() => {
                                const photos = selectedProfile.photos.length > 0
                                    ? [
                                        ...selectedProfile.photos.filter(p => p.is_primary === 1),
                                        ...selectedProfile.photos.filter(p => p.is_primary !== 1)
                                    ]
                                    : [{ path: user1 }];

                                return (
                                    <Box>
                                        {/* Carousel */}
                                        <SwipeableViews
                                            index={photoIndex}
                                            onChangeIndex={(index) => setPhotoIndex(index)}
                                            enableMouseEvents
                                        >
                                            {photos.map((photo, idx) => (
                                                <Box
                                                    key={idx}
                                                    sx={{
                                                        height: { xs: 260, sm: 320, md: 360 },
                                                        backgroundImage: `url(${apilink.base_link}/storage/${photo.path})`,
                                                        backgroundSize: "cover",
                                                        backgroundPosition: "center",
                                                        position: "relative",
                                                    }}
                                                >
                                                    {/* Fullscreen button */}
                                                    <IconButton
                                                        onClick={() => setFullScreenOpen(true)}
                                                        sx={{
                                                            position: "absolute",
                                                            top: 8,
                                                            right: 8,
                                                            bgcolor: "rgba(0,0,0,0.4)",
                                                            color: "#fff",
                                                            borderRadius: "50%",
                                                            p: 0.8,
                                                            "&:hover": { bgcolor: "rgba(0,0,0,0.6)" },
                                                        }}
                                                    >
                                                        <OpenInFullIcon />
                                                    </IconButton>

                                                    {/* Swipe hint */}
                                                    {photos.length > 1 && (
                                                        <Typography
                                                            sx={{
                                                                position: "absolute",
                                                                bottom: 8,
                                                                left: "50%",
                                                                transform: "translateX(-50%)",
                                                                bgcolor: "rgba(0,0,0,0.4)",
                                                                color: "#fff",
                                                                px: 1.5,
                                                                py: 0.5,
                                                                borderRadius: 1,
                                                                fontSize: 12,
                                                            }}
                                                        >
                                                            Swipe photos
                                                        </Typography>
                                                    )}

                                                    {/* Photo counter */}
                                                    {photos.length > 1 && (
                                                        <Typography
                                                            sx={{
                                                                position: "absolute",
                                                                top: 8,
                                                                left: 8,
                                                                bgcolor: "rgba(0,0,0,0.5)",
                                                                color: "#fff",
                                                                px: 1,
                                                                py: 0.5,
                                                                borderRadius: 1,
                                                                fontSize: 12,
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            {photoIndex + 1} / {photos.length}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            ))}
                                        </SwipeableViews>

                                        {/* Fullscreen modal */}
                                        <Dialog
                                            open={fullScreenOpen}
                                            onClose={() => setFullScreenOpen(false)}
                                            fullScreen
                                            PaperProps={{
                                                sx: {
                                                    bgcolor: "#ffffff",   // White background
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    position: "relative",
                                                },
                                            }}
                                        >
                                            {/* Close Button */}
                                            <IconButton
                                                onClick={() => setFullScreenOpen(false)}
                                                sx={{
                                                    position: "absolute",
                                                    top: 16,
                                                    left: 16,
                                                    bgcolor: "#e0e0e0", // light gray circle
                                                    color: "#000",
                                                    width: 36,
                                                    height: 36,
                                                    borderRadius: "50%",
                                                    "&:hover": { bgcolor: "#d0d0d0" },
                                                    zIndex: 10,
                                                }}
                                            >
                                                <CloseIcon />
                                            </IconButton>

                                            {/* Swipeable Photos */}
                                            <SwipeableViews
                                                index={photoIndex}
                                                onChangeIndex={(index) => setPhotoIndex(index)}
                                                enableMouseEvents
                                                style={{ width: "100%", maxWidth: 420 }}
                                            >
                                                {photos.map((photo, idx) => (
                                                    <Box
                                                        key={idx}
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            height: "100vh", // full viewport height
                                                        }}
                                                    >
                                                        <img
                                                            src={`${apilink.base_link}/storage/${photo.path}`}
                                                            alt={`photo-${idx}`}
                                                            style={{
                                                                maxHeight: "100%",
                                                                maxWidth: "100%",
                                                                objectFit: "contain",
                                                                borderRadius: 8,
                                                            }}
                                                        />
                                                    </Box>
                                                ))}
                                            </SwipeableViews>
                                        </Dialog>

                                    </Box>
                                );
                            })()}

                            <CardContent>
                                <Typography variant="h5">
                                    {selectedProfile.display_name}, {selectedProfile.age}
                                </Typography>
                                <Typography mt={1}>{selectedProfile.bio}</Typography>
                                <Typography mt={4}>Looking for: {selectedProfile.relation_type}</Typography>
                            </CardContent>
                        </Card>
                    </Box>
                )}




                {onview === "match" && matchedProfile && (
                    <Box textAlign="center" mt={5}>
                        <WhatshotIcon sx={{ fontSize: 60, color: "hotpink" }} />
                        <Typography variant="h5" mt={2}>
                            It's a match!
                        </Typography>
                        <Typography color="text.secondary" mt={1}>
                            You and {matchedProfile.profile.display_name} like each other.
                        </Typography>

                        {/* Matched profile preview */}
                        <Card sx={{ maxWidth: 320, mx: "auto", mt: 3, borderRadius: 3 }}>
                            <Box
                                sx={{
                                    height: 220,
                                    backgroundImage: `url(${apilink.base_link}/storage/${matchedProfileImg})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    borderTopLeftRadius: 3,
                                    borderTopRightRadius: 3,
                                }}
                            >
                                <IconButton
                                    sx={{
                                        alignSelf: "center",
                                        justifySelf: "center",
                                        bgcolor: "rgba(130, 49, 49, 0.85)",
                                    }}
                                    onClick={() => {
                                        profileView(matchedProfile, "Match");
                                    }}
                                >
                                    <InfoOutlinedIcon />
                                </IconButton>
                            </Box>
                            <CardContent>
                                <Typography variant="h6">
                                    {matchedProfile.profile.display_name}, {matchedProfile.profile.age}
                                </Typography>
                                {matchedProfile.profile.relation_type && (
                                    <Typography variant="body2" color="text.secondary">
                                        {matchedProfile.profile.relation_type}
                                    </Typography>
                                )}
                                {/* Optional: show hobbies */}
                                {matchedProfile.hobbies && matchedProfile.hobbies.length > 0 && (
                                    <Box mt={1} display="flex" flexWrap="wrap" gap={1} justifyContent="center">
                                        {matchedProfile.hobbies.map((hobby, idx) => (
                                            <Chip key={idx} label={hobby.name || hobby} size="small" />
                                        ))}
                                    </Box>
                                )}
                            </CardContent>
                        </Card>

                        {/* Actions */}
                        <Box mt={3} display="flex" justifyContent="center" gap={2}>
                            <Button
                                variant="outlined"
                                onClick={() => setOnview("swipes")}
                            >
                                Keep Swiping
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => goToChat(`${matchId}`, `${matchedProfile.profile.user_id}`, `${matchedProfile.profile.display_name}`, `${matchedProfileImg}`)}
                            >
                                Say Hi 👋
                            </Button>

                        </Box>
                    </Box>
                )}


                {onview === "filters" && (
                    <Box>
                        {/* Age range */}
                        <Typography gutterBottom>
                            Age: {filters.age_min} - {filters.age_max}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
                            <TextField
                                type="number"
                                label="Min"
                                value={filters.age_min}
                                onChange={(e) =>
                                    setFilters({
                                        ...filters,
                                        age_min: Math.max(18, Math.min(e.target.value, filters.age_max)),
                                    })
                                }
                                inputProps={{
                                    min: 18, // minimum allowed
                                    max: 40, // cannot exceed max
                                }}
                                fullWidth
                            />
                            <TextField
                                type="number"
                                label="Max"
                                value={filters.age_max}
                                onChange={(e) =>
                                    setFilters({ ...filters, age_max: Number(e.target.value) })
                                }
                                fullWidth
                            />
                        </Box>

                        {/* Distance */}
                        <Typography gutterBottom>
                            Distance (km)
                        </Typography>
                        <TextField
                            type="number"
                            value={filters.distance_km}
                            onChange={(e) =>
                                setFilters({ ...filters, distance_km: Number(e.target.value) })
                            }
                            fullWidth
                            sx={{ mb: 3 }}
                        />

                        {/* Show me */}
                        <Typography gutterBottom>Show me</Typography>
                        <Box sx={{ display: "flex", gap: 1, mb: 4 }}>
                            {["male", "female", "everyone"].map((g) => (
                                <Button
                                    key={g}
                                    variant={filters.show_me === g ? "contained" : "outlined"}
                                    onClick={() => setFilters({ ...filters, show_me: g })}
                                    sx={{
                                        flex: 1,
                                        bgcolor: filters.show_me === g ? "#010832" : "transparent",
                                        borderColor: "#010832",
                                        color: filters.show_me === g ? "#fff" : "#010832",
                                        "&:hover": {
                                            bgcolor: filters.show_me === g ? "#b81820" : "rgba(217,31,40,0.1)",
                                            borderColor: "#010832",
                                        },
                                    }}
                                >
                                    {g}
                                </Button>
                            ))}
                        </Box>

                        {/* Actions */}
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{
                                mb: 1,
                                bgcolor: "#010832",
                                "&:hover": { bgcolor: "#b81820" },
                            }}
                            onClick={() => {
                                console.log("Applied filters:", filters);
                                setOnview("swipes");
                                // later: refetch profiles with filters
                            }}
                        >
                            Apply Filters
                        </Button>

                        <Button
                            variant="outlined"
                            fullWidth
                            sx={{
                                borderColor: "#010832",
                                color: "#010832",
                            }}
                            onClick={() => setOnview("swipes")}
                        >
                            Cancel
                        </Button>
                    </Box>
                )}
            </Box>
            {/* Bottom Tab */}
            <Paper elevation={6} sx={tabStyle}>
                <BottomNavigation
                    value={tab}
                    sx={{
                        height: 66,
                        paddingTop: "6px",
                        paddingBottom: "6px",
                        borderRadius: "10px",
                        backgroundImage: `
                    linear-gradient(to right, rgba(255,255,255,0.9), rgba(255,255,255,0.7)),
                    url(${heartsBg2})
                    `,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        "& .MuiBottomNavigationAction-root": {
                            color: "#999", // inactive
                        },
                        "& .MuiBottomNavigationAction-root.Mui-selected": {
                            color: "#010832", // active icon + label
                        },
                    }}
                    onChange={(e, v) => {
                        setTab(v);
                        if (v === 1) navigate("/activity");
                        if (v === 2) navigate("/chats");
                        if (v === 3) navigate("/profile");
                    }}


                    showLabels
                >
                    <BottomNavigationAction label="Explore" icon={<WhatshotIcon />} />
                    <BottomNavigationAction
                        label="Connections"
                        icon={
                            <Badge badgeContent={5} color="error">
                                <FavoriteIcon />
                            </Badge>
                        }
                    />

                    <BottomNavigationAction label="Chats" icon={<ChatIcon />} />
                    <BottomNavigationAction label="Profile" icon={<PersonIcon />} />
                </BottomNavigation>
            </Paper>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </Box>
    );
}

const tabStyle = {
    position: "fixed",
    bottom: 12,
    left: "50%",
    transform: "translateX(-50%)",
    width: "calc(100% - 24px)",
    maxWidth: 420,
    borderRadius: 18
};